(() => {
  if (window.ToraAccessoryConversionProduct) return;

  const selectImage = (button) => {
    const gallery = button.closest('[data-tora-accessory-gallery]');
    const mainImage = gallery?.querySelector('.tora-accessory-product__main-image');
    const imageUrl = button.dataset.imageUrl;
    if (!gallery || !mainImage || !imageUrl) return;

    mainImage.src = imageUrl;
    mainImage.removeAttribute('srcset');

    gallery.querySelectorAll('[data-tora-accessory-thumbnail]').forEach((thumbnail) => {
      const isSelected = thumbnail === button;
      thumbnail.classList.toggle('is-active', isSelected);
      if (isSelected) thumbnail.setAttribute('aria-current', 'true');
      else thumbnail.removeAttribute('aria-current');
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-tora-accessory-thumbnail]');
    if (button) selectImage(button);
  });

  window.ToraAccessoryConversionProduct = { selectImage };
})();
